import React, { useState, useEffect } from 'react';
import MapboxComponent from '../components/MapboxComponent';
import Layout from '../components/Layout';

const Dashboard = () => {
  const [showStats, setShowStats] = useState(false);

  useEffect(() => {
    if (showStats) {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: 'smooth'
      });
    }
  }, [showStats]);

  return (
    <Layout>
      <div className="space-y-8">
        <MapboxComponent />
      </div>
    </Layout>
  );
};

export default Dashboard;


